import React, { memo } from 'react'
import { Chip, Box } from '@mui/material'
import { Patient } from '@/features/patients/types/patients'
import {
  ActionGroup,
  ActionStatus,
} from '@/features/patient-actions/types/patientActions'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'
import {
  ACTION_GROUP_LABELS,
  ACTION_STATUS_LABELS,
} from '@/apps/legacy/constants/patientConstants'

interface PatientNeedCheckCellProps {
  patient: Patient
}

interface ActionTag {
  label: string
  groupKey: ActionGroup
  statusKey: ActionStatus
  groupLabel: string
  statusLabel: string
  count: number
}

const PatientNeedCheckCell: React.FC<PatientNeedCheckCellProps> = ({
  patient,
}) => {
  const tags: ActionTag[] = []

  // アクションサマリーがある場合、グループ×ステータスのタグを生成
  if (patient.action_summary) {
    Object.entries(patient.action_summary).forEach(([group, statuses]) => {
      if (statuses) {
        Object.entries(statuses).forEach(([status, count]) => {
          if (count && count > 0) {
            const groupKey = group as ActionGroup
            const statusKey = status as ActionStatus
            const groupLabel = ACTION_GROUP_LABELS[groupKey]
            const statusLabel = ACTION_STATUS_LABELS[statusKey]

            tags.push({
              label: `${groupLabel} ${statusLabel}`,
              groupKey,
              statusKey,
              groupLabel,
              statusLabel,
              count,
            })
          }
        })
      }
    })
  }

  if (tags.length === 0) {
    return <Box />
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag.label}
          size="small"
          sx={{
            backgroundColor: colorTokens.action.primaryBgLight,
            color: colorTokens.blue[600],
            border: `1px solid ${colorTokens.blue[600]}`,
            height: 24,
            '& .MuiChip-label': {
              px: 1,
            },
            '&:hover': {
              backgroundColor: colorTokens.action.primaryBgHover,
            },
          }}
        />
      ))}
    </Box>
  )
}

export default memo(PatientNeedCheckCell)
